import fetchCommerceToolsGraphQLApi from "../fetchCommerceToolsGraphQLApi"
import formatConfigurationGroupProduct from "@secureo/common/utils/commerceTools/formatters/formatConfigurationGroupProduct"

import { CurrencyCode } from "@secureo/common/typings/Forex"
import { RawProduct } from "./fetchProduct"

const fetchConfigurationGroupProducts = async (
	accessToken: string,
	skus: string[],
	currencyCode: CurrencyCode,
	language = "de",
) => {
	if (skus.length === 0) return []

	const query = /* GraphQL */ `
		fragment Variant on ProductVariant {
			id
			sku
			prices {
				country
				channel {
					key
				}
				value {
					centAmount
					currencyCode
				}
			}
			images {
				url
			}
			attributesRaw(includeNames: ["msrpPrice", "deliveryTimeWorkdays"]) {
				name
				value
			}
		}

		query configurationGroupProducts($skus: [String!]!, $language: Locale!) {
			products(skus: $skus, limit: 100) {
				results {
					id
					masterData {
						current {
							name(locale: $language)
							description(locale: $language)
							masterVariant {
								...Variant
							}
						}
					}
				}
			}
		}
	`

	const data = (await fetchCommerceToolsGraphQLApi(accessToken, query, {
		skus,
		language,
	})) as {
		products: { results: RawProduct[] }
	}

	const configurationGroupProducts = data?.products?.results ?? []

	const formattedConfigurationGroupProducts = configurationGroupProducts.map(
		(configurationGroupProduct) =>
			formatConfigurationGroupProduct(configurationGroupProduct, currencyCode),
	)

	return formattedConfigurationGroupProducts
}

export default fetchConfigurationGroupProducts
